import Grid from '../../components/Grid';
import PacienteService from '../../services/paciente_service.js';
import routeService from '../../services/route_service.js';
import AlertService from '../../services/alert_service.js';
import GeneralService from '../../services/general_service.js';
import LoginService from '../../services/login_service.js';
import ObraSocialService from '../../services/obras_sociales_service.js';
import SedeService from '../../services/sede_service.js';

const alertService = new AlertService();
const loginService = new LoginService();
const generalService = new GeneralService();
const pacienteService = new PacienteService();
const obraSocialService = new ObraSocialService();
const sedeService = new SedeService();
let _this = null;
let search =JSON.stringify({page:1, offset: 10, nombrePaciente: '', apellidoPaciente: '', dniPaciente: '', idObraSocialPaciente: '', historiaClinicaPaciente: '', estadoPaciente: '', sexoPaciente: '', idSedePaciente: '', activoPaciente: '', exportTo: '', columns: []});
export default {
	name: 'pacientes',
	components: { Grid },
	props: {
		titulo: String, 
		actions: Array,
		noDataGet: Boolean,
		columns: Array,
		cellClick: {
			type: Function,
			default() {
				return true;
			}
		}		
	},
	data: function() {
		return {
			searchQuery: '',
			maxPage: 0,
			search: JSON.parse(search),
			submited: false,
			obrasSociales: [],
			buscando: false,
			data: [],
			sedes: [],
			loginService: loginService,
			hasPermission: true,
			cantPaginas: 1
		}
	}, 
	created: function () {
		_this = this;
		this.submited = false;
		this.getSedes();
		if(!loginService.hasPermission("listado", "pacientes")) {
			routeService.goToHome();
			return;
		}
		this.getObrasSociales();
		if(!this.noDataGet)
			this.getData();
	}, 
	methods: { 
		getData: function () {
			this.buscando = true;
			pacienteService.countPacientes(this.search).then(function(response) {
				_this.maxPage = 0;
				if(response.body) {
					if(!isNaN(response.body) && !isNaN(response.body) && _this.search.offset > 0) {
						_this.maxPage = Math.ceil(response.body / _this.search.offset);
					}
				}
			});
			pacienteService.get(this.search).then(function(response) {
				_this.buscando = false;
				if(_this.search.exportTo == '') {
					_this.data = [];
				} else {
					_this.search.exportTo = ''
					if(response.body && response.body.file) {
						let route = routeService.getPublicPath() + response.body.file.substring(response.body.file.indexOf("public") + 7);
						window.open(route);
					}
					return true;
				}
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.data.push({
							idPaciente: value.idPaciente,
							nombrePaciente: value.nombrePaciente,
							apellidoPaciente: value.apellidoPaciente,
							dniPaciente: value.dniPaciente,
							obraSocialPaciente: value.obraSocialPaciente,
							nombreObraSocialPaciente: value.obraSocialPaciente.nombreObraSocial,
							sedePaciente: value.sedePaciente.nombreSede,
							statusPaciente: value.statusPaciente,
							cantidadCirugias: value.cantidadCirugias ? value.cantidadCirugias : "NO",
							idSedePaciente: value.idSedePaciente,
							idHcPaciente: value.idHcPaciente,
							nroHcPaciente: value.nroHcPaciente.indexOf(" - ") > 0 ? value.nroHcPaciente.substring(0, value.nroHcPaciente.indexOf(" - ")) : value.nroHcPaciente,
							sexoPaciente: value.sexoPaciente == 1 ? 'M' : 'F',
							fechaNacimientoPaciente: generalService.fechaSpanish(value.fechaNacimientoPaciente),
							edadPaciente: value.edadPaciente,
							activoPaciente: value.activoPaciente == 1 ? 'SI' : 'NO',
							col1Paciente: value.col1Paciente,
							col2Paciente: value.col2Paciente,
							col3Paciente: value.col3Paciente,
						}); 
					} 
				} 
			}, function(error) { 
				_this.search.exportTo = ''
				_this.buscando = false;
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getObrasSociales: function() {
			_this.obrasSociales = [];
			obraSocialService.get({}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						if(value.activoObraSocial == 1) {
							_this.obrasSociales.push(value);
						}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		limpiar() {
			this.search = JSON.parse(search);
			this.getData();
		}, 
		agregar: function () {
			if(!loginService.hasPermission("alta", "pacientes")) {
				routeService.goToHome();
				return;
			}
			routeService.goTo('paciente');
		},
		editar: function (item) {
			if(!loginService.hasPermission("editar", "pacientes")) {
				routeService.goToHome();
				return;
			}
			routeService.goTo('paciente/' + item.idPaciente);
		},
		getSedes: function() {
			_this.sedes = [{idSede:"", nombreSede:"Sede"}];
			sedeService.get({}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						//if(value.activoObraSocial == 1) {
							_this.sedes.push(value);
						//}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		siguiente: function() {
			_this.search.page++;
			_this.getData();
		},
		anterior: function() {
			if(_this.search.page != 1)
				_this.search.page--;
			_this.getData();
		},
		changePage: function(page) {
			_this.search.page = page;
			_this.getData();
		},
		bindClass(item) {
			if(item.activoPaciente == "NO")
				return "desactivado";
		},
		exportar() {
			this.search.exportTo = "excel";
			this.search.columns = this.columns;
			this.getData();
		},
		buscar() {
			_this.search.page = 1;
			_this.getData();
		}
	}
}